<div class="spinner d-flex justify-content-center align-items-center w-100" *ngIf="routerChanged">    
    <div class="spinner-border text-secondary" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>

